module.exports = __webpack_public_path__ + "img/banner-administracao.8ed8c45b.jpg";